import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { HELP_LINKS } from '../../../../../constants/HelpLinks';
import { useTrackLearnMoreClickAnalytics } from '../../../../../utils/hooks/bi/useTrackLearnMoreClickAnalytics';
import { HelpLink, Text } from '../../../../../components/common';
import styles from '../NoItemsBottomPart/NoItemsBottomPart.scss';
import { IOuter } from './DeleteFlowPanelInformation.types';
import { NavItemTitle } from '../NavItemTitle';

export const DeleteFlowPanelInformation: FC<IOuter> = ({ clickOrigin }) => {
  const { trackLearnMoreClick } = useTrackLearnMoreClickAnalytics();
  const handleHelpLinkClick = useCallback(() => {
    trackLearnMoreClick(clickOrigin);
  }, [trackLearnMoreClick, clickOrigin]);

  return (
    <div data-hook="delete-flow-panel-information">
      <NavItemTitle className={styles.info}>
        <FormattedMessage id="panel.bottom-parts.no-items-bottom-part.important" />
      </NavItemTitle>

      <Text weight="thin" size="small" secondary tagName="div" className={styles.infoContent}>
        <FormattedMessage
          id="panel.bottom-parts.no-items-bottom-part.trash-empty.new-flow"
          values={{
            readMoreLink: (
              <HelpLink article={HELP_LINKS.DELETE_FLOW_READ_MORE} size="small" onClick={handleHelpLinkClick}>
                <FormattedMessage id="panel.bottom-parts.no-items-bottom-part.trash-empty.new-flow.read-more" />
              </HelpLink>
            ),
          }}
        />
      </Text>
    </div>
  );
};
